import Swiper from 'swiper/dist/js/swiper.min';

function handleHorizontalStepsSliders() {
    const sliders = document.querySelectorAll(".horizontal-steps-slider");

    sliders.forEach(slider => {
        if (!slider.swiperInstance) {
            slider.swiperInstance = new Swiper(slider, {
                loop: false,
                slidesPerView: 3, // default for desktop
                spaceBetween: 24,
                direction: 'horizontal',
                grabCursor: true,
                resistanceRatio: 0,
                scrollbar: {
                    el: slider.querySelector('.swiper-scrollbar'),
                    draggable: true,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 1.2, // mobile
                    }
                }
            });
        }
    });
}

jQuery(document).ready(function ($) {

    handleHorizontalStepsSliders();
    window.addEventListener("resize", handleHorizontalStepsSliders);

    let fadeSlider = new Swiper(".fade-slider", {
        spaceBetween: 30,
        effect: "fade",
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        }
    });

    if ($(window).width() > 767) {

        let cardSlider = new Swiper('.card-slider ', {
            loop: true,
            slidesPerView: 3,
            spaceBetween: 56,
            centeredSlides: true,
            direction: 'horizontal',
            freeMode: false,
            autoplay: {
                delay: 0,
                disableOnInteraction: true
            },
            speed: 6000,
            grabCursor: true,
            breakpoints: {
                560: {
                    slidesPerView: 1,
                    spaceBetween: 20
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 56
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 56
                }
            }
        });
    }

    let logoSlider = new Swiper('.logo-slider ', {
        loop: true,
        slidesPerView: 7,
        spaceBetween: 100,
        centeredSlides: true,
        direction: 'horizontal',
        autoplay: true,
        breakpoints: {
            560: {
                slidesPerView: 3,
                spaceBetween: 56
            },
            768: {
                slidesPerView: 4,
                spaceBetween: 56
            },
            992: {
                slidesPerView: 7,
                spaceBetween: 56
            }
        }
    });

    if ($(window).width() > 767) {

        let historySlider = new Swiper('.history-slider ', {
            loop: false,
            slidesPerView: 3,
            spaceBetween: 40,
            navigation: {
                nextEl: ".arrow--next",
                prevEl: ".arrow--prev",
            },
        });
    }
});
